function areUrlsEqual (url1, url2) {
    return new URL(url1).toString()?.toLowerCase().replace(/\/$/, '') === new URL(url2).toString()?.toLowerCase().replace(/\/$/, '');
}

export default areUrlsEqual;